var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common-tips" },
    [
      _c("transition", { attrs: { name: "drop" } }, [
        _vm.isShow
          ? _c("div", { staticClass: "tips-body" }, [
              _c("div", { staticClass: "tips-text" }, [
                _vm._v(_vm._s(_vm.text))
              ])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-088e2394", { render: render, staticRenderFns: staticRenderFns })
  }
}